import React, { useEffect, useState } from "react";
import Common_Back_Btn from "../../../../../common/common_components/common_back_btn/Common_Back_Btn";

import Common_Report_Offcanvas from "../../common_report_offcanvas/Common_Report_Offcanvas";
import Quality_Control_Plan_Table from "./quality_control_plan_table/Quality_Control_Plan_Table";
import Quality_Control_Plan_Filter from "./quality_control_plan_filter/Quality_Control_Plan_Filter";
import {
  GetCustomerReport,
  GetQualityControlReport,
} from "../../../../../features/admin/report_generator/Slice";
import { useDispatch, useSelector } from "react-redux";
import { GetAll } from "../../../../../features/admin/quality_management/process_requirement/quality_control/Slice";
import { FixIDS } from "../../../../../utils/fixIDS";


const Quality_Control_Plan = () => {
  const [show, setShow] = useState(false);

  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const quality_control_plan = useSelector(
    (state) => state.quality_control_plan,
  );
  const [searchParams, setSearchParams] = useState({
    certified_value: "",
    verification_type_id: "",
    end_date: "",
    start_date: "",
  });
  const fetchCustomers = async (page = 1) => {
    await dispatch(
      GetAll({
        page,
        per_page: quality_control_plan.per_page,
        verification_type_id: searchParams?.verification_type_id,
        certified_value: searchParams?.certified_value,
        end_date: searchParams?.end_date,
        start_date: searchParams?.start_date,
      }),
    );
  };

  const permissions = useSelector((state) => state.auth.permissions);
  const haveReportPermission = permissions?.includes(FixIDS.quality_control_plan_report.Report);

  useEffect(() => {
    fetchCustomers(currentPage);
  }, [searchParams, currentPage]);

  const [showLottie, setShowLottie] = useState(true);
  const [reportPath, setReportPath] = useState("");
  const reportgenerate = async () => {
    setShow(true);
    setShowLottie(true);
    const response = await dispatch(GetQualityControlReport({
        page:1,
        per_page: quality_control_plan.per_page,
        verification_type_id: searchParams?.verification_type_id,
        certified_value: searchParams?.certified_value,
        end_date: searchParams?.end_date,
        start_date: searchParams?.start_date,
      }));

    if (response?.meta?.requestStatus === "fulfilled") {
      const path = response?.payload?.path;
      setReportPath(path);
      setShowLottie(false);
    } else {
      setShowLottie(false); // also stop loader on error
    }
  };
  return (
    <section className="Sample_Report">
      <div className="back_div">
        <Common_Back_Btn backText="Quality Control Plan Report" />
      </div>

      <div className="Sample_Report_Filter_div">
        <Quality_Control_Plan_Filter
          searchParams={searchParams}
          setSearchParams={setSearchParams}
          setShow={setShow}
          reportgenerate={reportgenerate}
        />
      </div>

      <div className="report_table_div">
        { haveReportPermission && <Quality_Control_Plan_Table
          setCurrentPage={setCurrentPage}
          currentPage={currentPage}
          quality_control_plan={quality_control_plan}
        />}
      </div>

      <Common_Report_Offcanvas
        reportPath={reportPath}
        reportgenerate={reportgenerate}
        setShowLottie={setShowLottie}
        showLottie={showLottie}
        title={"Quality Control Plan Report"}
        show={show}
        setShow={setShow}
        handleClose={() => {
          setShow(false);
        }}
      />
    </section>
  );
};

export default Quality_Control_Plan;
